import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ElectronicSignaturePasswordRequest from './ElectronicSignaturePasswordRequest';

interface Props extends BaseModalProps {
	onVerify: () => void;
	submitButtonText?: string;
}

const ElectronicSignaturePasswordRequestModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.electronicSignaturePasswordRequest.modalTitle'>
			<ElectronicSignaturePasswordRequest
				onVerify={props.onVerify}
				submitButtonText={props.submitButtonText}
			/>
		</BaseModal>
	);
};

export default ElectronicSignaturePasswordRequestModal;
